export default __webpack_public_path__ + "static/media/principalFinanceGroup.526b7fb1.png";